import * as Sentry from "@sentry/capacitor";
import {Preferences} from "@capacitor/preferences";

const AUTO_PRINT_RECEIPTS_KEY = "autoPrintReceipts";

export async function getStoredAutoPrintReceipts() {
    try {
        const {value} = await Preferences.get({key: AUTO_PRINT_RECEIPTS_KEY});
        return value;
    } catch (err) {
        Sentry.captureException(err);
        return null; // this shouldn't happen
    }
}

export async function setStoredAutoPrintReceipts(autoPrintReceipts: boolean) {
    await Preferences.set({
        key: AUTO_PRINT_RECEIPTS_KEY,
        value: autoPrintReceipts.toString(),
    });
}
